import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAMRPTvCbg3aQifre30yUawZu7VwBnABeo",
  authDomain: "challenge-1d6ef.firebaseapp.com",
  projectId: "challenge-1d6ef",
  storageBucket: "challenge-1d6ef.appspot.com",
  messagingSenderId: "282690146367",
  appId: "1:282690146367:web:fe577e9bca850df98fe88a",
  measurementId: "G-5WCYTZVLFS"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };